export default {
  routeSchedules: 'Rota Saatleri',
  Inbound: 'Kampüs Varışlılar',
  Outbound: 'Kampüs Çıkışlılar',
  originalSchedules: 'Orjinal Planlamalar',
  temporarySchedules: 'Geçici Planlamalar',
  changeArrivalTimes: 'Varış Saatlerini Değiştir',
  changeDepartureTimes: 'Kalkış Saatlerini Değiştir',
  departureLocation: 'Çıkış Konumu',
  arrivalTimeLastCampus: 'Son Kampüse Varış Saati',
  departureTimesFirstCampus: 'İlk Kampüsten Ayrılış Saatleri',
  arrivalTimeChangePrompt: '<b> son kampüse varış saatlerini nasıl değiştirmek istediğinizi seçin:',
  departureTimeChangePrompt: '<b> ilk kampüsten hareket saatlerini nasıl değiştirmek istediğinizi seçin:',
  setToASpecificTime: 'Seçilen saate çek',
  laterArrivalBy: 'Seçilen süre kadar ötele',
  earlierArrivalBy: 'Seçilen süre kadar öne al',
  laterDepartureBy: 'Daha Sonra Ayrıl',
  earlierDepartureBy: 'Daha Erken Ayrıl',
  datesForWhichThisChangeWillApply: 'Bu değişikliğin uygulanacağı tarihler',
  editStopTimesManually: 'Duraklama saatlerini manuel olarak düzenle',
  fromPlannedTime: 'planlanan zamandan itibaren',
  showBothArrivalAndDepartureTimes: 'Varış ve kalkış saatlerini birlikte göster',
  saveInstructions:
    'Kaydet butonuna bastığınızda tüm duraklar için saatler otomatik olarak hesaplanacaktır. Durak saatlerini kendiniz düzenlemek istiyorsanız aşağıdaki kutuyu işaretleyin.',
  originalArrivalTime: 'Orjinal Varış Saati',
  temporaryArrivalTime: 'Geçici Varış Saati',
  originalDepartureTime: 'Orjinal Çıkış Saati',
  temporaryDepartureTime: 'Geçici Çıkış Saati',
  validFrom: 'Başlangıç',
  validUntil: 'Bitiş',
  until: 'Bitiş',
  destination: 'Varış Noktası',
  arrive: 'Varış',
  depart: 'Çıkış',
  departureTime: 'Çıkış',
  arrivalTime: 'Varış',
  specificGroupName: '{0} Saatleri {1} Olarak Değiştirildi',
  earlyGroupName: '{0} {1} Öne Çekildi',
  arriveGroupName: '{0} {1} Ötelendi',
  hour: 'Saat',
  hours: 'Saat',
  minute: 'Dakika',
  showAllStops: 'Tüm durakları göster',
  showAverage: 'Ortalama gerçekleşen saatleri göster',
  filterByAverageDelay: 'Ortalama durak gecikmesine göre filtrele',
  grid: {
    route: 'Rota',
    serviceTime: 'Servis Süresi',
    min: 'dk',
    checkIn: 'Check-in',
    depotDeparture: 'Depo Çıkışı',
    nthStopDepArr: '{0}. Durak {1}',
    lastStop: 'Son Durak {0}',
    lastStopArrival: 'Son Durak Varış',
    departure: 'Kalkış',
    arrival: 'Varış',
    defaultTimes: 'Planlanan Saatler',
    actualTimes: 'Gerçekleşen Saatler',
    successDeletedText: 'Geçici rota saati başarıyla silindi',
    applyActualTimes: 'Gerçekleşen Saatleri Uygula',
    deleteSchedules: 'Planlamayı Sil',
  },
  // Edit Mode
  editSchedules: 'Saatleri Düzenle',
  editRouteSchedules: 'Rota Saatlerini Düzenle',
  editTemporaryRouteSchedule: 'Geçici Rota Saatini Düzenle',
  forTheSelectedPeriod: 'Seçilen dönem için',
  permanently: 'Kalıcı olarak',
  calculateAll: 'Tümünü Hesapla',
  calculateAllBasedOnFirstStop: 'İlk Durağa Göre Tümünü Hesapla',
  calculateAllBasedOnLastStop: 'Son Durağa Göre Tümünü Hesapla',
  resetAll: 'Tümünü Sıfırla',
  showAverageActualTimesFor: 'Ortalama gerçekleşen saatleri göster',
  thisMonth: 'Bu ay',
  last7Days: 'Son 7 Gün',
  thisWeek: 'Bu Hafta',
  customDates: 'Özel Tarihler',
  applyActualTimes: 'Gerçekleşen Saatleri Uygula',
  onlyRoutesWithDefaultCampusTimes: 'Sadece varsayılan kampüs saatlerine sahip rotalara',
  updateArrivalTimesForAllRoutes: 'Tüm rotalar için varış saatlerini güncelle',
  updateDepartureTimesForAllRoutes: 'Tüm rotalar için kalkış saatlerini güncelle',
  updateArrivalTimesAndCalculateAllRoutes: 'Varış Saatlerini Güncelle ve Tüm Rotaları Hesapla',
  updateDepartureTimesAndCalculateAllRoutes: 'Kalkış Saatlerini Güncelle ve Tüm Rotaları Hesapla',
  setToSpecificArrivalTime: 'Belirli bir varış saatine ayarla',
  setToSpecificDepartureTime: 'Belirli bir kalkış saatine ayarla',
  fromTheScheduledTime: 'planlanan saatten',
  referenceTimeForCalculation: 'Hesaplama için referans saat',
  deleteSchedule: 'Planlamayı Sil',
  confirmDeleteSchedule:
    '{0} rotası için {1} – {2} tarihleri arasında geçerli olan planlama takvimini silmek istediğinizi onaylıyor musunuz?',
  confirmCancelChanges: 'İptal etmek istediğinize emin misiniz? Kaydedilmemiş değişiklikleriniz var.',
  quitEditingTitle: 'Düzenlemeyi Bırak',
  quitEditingMessage:
    'Düzenlemeyi bırakmak istediğinize emin misiniz? Rota planlamalarındaki değişiklikler henüz kaydedilmedi.',
  continueEditing: 'Düzenlemeye Devam Et',
  quit: 'Bırak',
  editingTemporaryScheduleInfo: 'Bu planlama {0} tarihinden {1} tarihine kadar geçerlidir',
  actions: {
    calculate: 'Hesapla',
    revertChanges: 'Değişiklikleri Geri Al',
    applyActualTimes: 'Gerçekleşen Saatleri Uygula',
  },
  errors: {
    calculationError: 'Rota Hesaplama Hatası',
    noRouteFound:
      'Duraklar arasında uygun bir rota bulunamadı. Lütfen istasyon konumlarını kontrol edip tekrar deneyin.',
    calculationFailed: 'Rota hesaplaması başarısız oldu. Lütfen durak saatlerini ve konumlarını doğrulayın.',
  },
};
